import React from 'react';
import { Box, Grid } from '@mui/material';
import CustomDropdown from '../../../components/CustomDropdownWithPlus';
import SearchableAddressDropdown from './SearchableAddressDropdown';

const OtherSupplierForm = ({
  formData,
  selectedSupplier,
  supplierOptions,
  addressOptions = [],
  handleSelect
}) => {
  return (
    <Grid
      item
      xs={6}
      sx={{
        pl: 2,
        backgroundColor: '#e6edf5',
        padding: '0px 20px',
        marginLeft: '0px',
        borderRadius: '5px'
      }}
    >
      <Box className="field">
        <CustomDropdown
          name="supplier"
          options={supplierOptions}
          handleSelect={handleSelect}
          minWidth="150px"
          selectedValue={formData.supplier}
          placeholder="Select Supplier"
          label="Supplier"
        />
      </Box>

      <Box className="field">
        <SearchableAddressDropdown
          name="supplierAddress"
          options={addressOptions}
          onSelect={(id) => handleSelect({ target: { value: id } }, 'supplierAddress')}
          selectedValue={formData.supplierAddress}
          placeholder="Search supplier addresses"
          label="Supplier Address"
        />
      </Box>
    </Grid>
  );
};

export default OtherSupplierForm;
